var _path, _circle, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyAchievements(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 15 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.4188 2.43352C6.61693 2.2177 6.95732 2.2177 7.15545 2.43352L7.90555 3.25058C8.04111 3.39824 8.20489 3.51723 8.38721 3.60053L9.39607 4.06142C9.66255 4.18317 9.76774 4.5069 9.62371 4.76202L9.07843 5.72789C8.97989 5.90244 8.91733 6.09498 8.89445 6.29412L8.76787 7.39603C8.73443 7.68709 8.45905 7.88716 8.17191 7.82902L7.08481 7.6089C6.88835 7.56912 6.6859 7.56912 6.48944 7.6089L5.40234 7.82902C5.1152 7.88716 4.83982 7.68709 4.80638 7.39603L4.6798 6.29412C4.65692 6.09498 4.59436 5.90244 4.49582 5.72789L3.95054 4.76202C3.80651 4.5069 3.9117 4.18317 4.17818 4.06142L5.18704 3.60053L4.97927 3.14574L5.18704 3.60053C5.36936 3.51723 5.53314 3.39824 5.6687 3.25058L5.30038 2.91244L5.6687 3.25058L6.4188 2.43352Z",
    stroke: "#252525"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6.7876,
    cy: 5.5,
    r: 5,
    stroke: "#252525"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.7876 9.5L1.2876 14.3636L3.7876 13.8182L4.7876 16L7.2876 10.5455",
    stroke: "#252525",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.82746 11.9788L8.29477 16.5719L9.8481 14.3041L12.1255 15.0951L10.2914 9.3537",
    stroke: "#252525",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyAchievements);
export default __webpack_public_path__ + "static/media/MyAchievements.a48da868bd8636d1a28c4ce6ec8c957d.svg";
export { ForwardRef as ReactComponent };